export function useSelectSorting() {
  const { t } = useI18n()

  const sortList = ref([
    { id: 'weightInCategory', title: t('casinoSort.weight') },
    { id: 'popularity', title: t('casinoSort.popular') },
    { id: 'rtp', title: t('casinoSort.rtp') },
    { id: 'createdAt', title: t('casinoSort.createdAt') },
    { id: 'nameAsc', title: t('casinoSort.nameAsc') },
    { id: 'nameDesc', title: t('casinoSort.nameDesc') },
  ])

  return { sortList }
}
